import React from 'react';
import { RoomAudioRenderer, StartAudio } from '@livekit/components-react';
import { SessionProvider } from '../components/alpha-agent/app/session-provider';
import { ViewController } from '../components/alpha-agent/app/view-controller';
import { Toaster } from '../components/alpha-agent/livekit/toaster';
import { APP_CONFIG_DEFAULTS } from '../config/alpha-agent-config';
import '../styles/alpha-agent/globals.css';

const AlphaAgent: React.FC = () => {
  // Use the default app configuration
  const appConfig = {
    ...APP_CONFIG_DEFAULTS,
    companyName: '44Agents',
    pageTitle: '44Agents Alpha Voice Agent',
    pageDescription: 'Experience our AI-powered voice agent',
    logo: '/alpha-agent/lk-logo.svg',
    logoDark: '/alpha-agent/lk-logo-dark.svg',
  };

  return (
    <div className="h-full w-full bg-background">
      <SessionProvider appConfig={appConfig}>
        <main className="grid h-full grid-cols-1 place-content-center">
          <ViewController />
        </main>
        <StartAudio label="Start Audio" />
        <RoomAudioRenderer />
        <Toaster />
      </SessionProvider>
    </div>
  );
};

export default AlphaAgent;
